import View from './view';
export const PollsTypeSurveyResultScreen = () => {
  return View({});
};
